import { GroupBadge } from '@/deploy/components/ui/GroupBadge';
import { useActiveGameGroup } from '@/stores/gameGroups.store';
import styles from './GameGroupBadge.module.scss';

interface GameGroupBadgeProps {
  size?: 'sm' | 'md';
  /** Texte avant le badge (« Groupe de jeu »), omis = badge seul. */
  caption?: string;
  /** Ligne à part sous un titre de modale, plutôt qu'en ligne dans le texte. */
  block?: boolean;
}

/**
 * Groupe de jeu qui recevra l'action (NationsGlory : Nova, Iris...), pour les confirmations et les
 * en-têtes de page. Raccourci du GroupBadge du Déploiement, qui lit le libellé et la couleur du
 * groupe actif. Ne rend RIEN pour un jeu sans groupes (Paladium) : ses écrans restent inchangés.
 */
export function GameGroupBadge({ size = 'sm', caption, block = false }: GameGroupBadgeProps) {
  const group = useActiveGameGroup();
  if (!group) return null;
  const badge = (
    <span className={styles.inline}>
      {caption && <span className={styles.caption}>{caption}</span>}
      <GroupBadge group={group} size={size} title={`Groupe de jeu : ${group.label}`} />
    </span>
  );
  // En bloc, l'alignement suit celui de la modale (centré ou à gauche) par text-align.
  return block ? <span className={styles.block}>{badge}</span> : badge;
}
